import React from "react";
import { Helmet } from "react-helmet-async";
import { Card, Button, Alert } from "react-bootstrap";

import SignIn from "../../components/auth/SignIn";
import avatar from "../../assets/img/avatars/avatar.jpg";
import avatar2 from "../../assets/img/avatars/avatar-3.jpg";
import { useNavigate } from "react-router-dom";
import { tenantOrigin } from "../../utils/apis";

import "./styles.css";

const SignInPage = () => {
  const navigate = useNavigate();
  const eventWork = async (e: any) => {
    console.log("get message111");
    console.log(e);
  };
  function handleClick(source: string) {
    window.open(
      `${tenantOrigin("dsp")}/api/user/auth/login/${source}`,
      "newwindow",
      "height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no" // <- This is what makes it open in a new window.
    );

    window.location.reload();
    navigate("/");
    window.location.reload();

    // window.addEventListener(
    //   "message",
    //   (e) => {
    //     eventWork(e).then(
    //       (value) => {
    //         console.log("5555", value); // Success!
    //       },
    //       (reason) => {
    //         console.error("6666", reason); // Error!
    //       }
    //     );
    //   },
    //   false
    // );
    // return window.removeEventListener("message", eventWork);
  }
  return (
    <React.Fragment>
      <Helmet title="Sign In" />
      <div className="text-center mt-4 w-80">
        <h2>Welcome back</h2>
        <p className="lead">Sign in to your account to continue</p>
      </div>

      <div className="d-flex p-2">
        <Card style={{ minWidth: "400px", marginRight: "20px" }}>
          <Card.Body>
            <div className="m-sm-4">
              <div className="text-center">
                <img
                  src={avatar}
                  alt="Chris Wood"
                  className="img-fluid rounded-circle"
                  width="132"
                  height="132"
                />
              </div>
              <SignIn />
            </div>
          </Card.Body>
        </Card>
        <Card style={{ minWidth: "400px" }}>
          <Card.Body>
            <div className="m-sm-4">
              <div className="text-center">
                <img
                  src={avatar2}
                  alt="a girl"
                  className="img-fluid rounded-circle"
                  width="132"
                  height="132"
                />
              </div>

              <div className="text-center">
                <Alert className="my-3 text-center" variant="primary">
                  <div className="alert-message">
                    Use your <strong>organisation</strong> account to sign in
                  </div>
                </Alert>
                {/* One button per party; only those with a working IdP behind
                    them are enabled. The multi-tenant openid-server provides
                    sls/council/frnsw (and dsp) — police and uts have no
                    identity provider or OAuth client. */}
                {[
                  { org: "sls", hasIdp: true },
                  { org: "council", hasIdp: true },
                  { org: "frnsw", hasIdp: true },
                  { org: "police", hasIdp: false },
                  { org: "uts", hasIdp: false },
                ].map(({ org, hasIdp }, index) => (
                  <Button
                    key={org}
                    type="button"
                    variant="primary"
                    size="lg"
                    className={`${index === 0 ? "mt-2" : "mt-4"} singinbutton`}
                    onClick={() => handleClick(org)}
                    disabled={!hasIdp}
                    title={hasIdp ? undefined : "No identity provider configured"}
                  >
                    Sign in as {org.toUpperCase()} User
                  </Button>
                ))}
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default SignInPage;
